import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import { colors, greys, palette } from "@clockwise/web-commons/src/styles/color.styles";

const content: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  zIndex: 1,
  position: "relative",
  minHeight: 300,
  paddingBottom: 20,
  width: "100%",
};

const background: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 0,
};

const h2: CSSProperties = {
  paddingTop: 20,
  paddingBottom: 5,
};

const h3: CSSProperties = {
  marginBottom: 0,
  paddingTop: 0,
  paddingBottom: 10,
  fontSize: 14,
};

const meeting: CSSProperties = {
  position: "relative",
  padding: 10,
  display: "block",
  cursor: "pointer",
  backgroundColor: greys.white,

  "&:hover": {
    backgroundColor: `${lighten(colors.blueCool.lightest, 0.7)} !important`,
  },
};

export const meetingChevron: CSSProperties = {
  position: "absolute",
  top: "calc(50% - 12px)",
  right: 10,
  color: colors.blueDusk.darker,
};

const cardButton: CSSProperties = {
  textAlign: "left",
  justifyContent: "flex-start",
  paddingLeft: 15,
  width: "100%",
};

const cardLabel: CSSProperties = {
  fontWeight: 600,
  color: palette.green,
  textOverflow: "ellipsis",
  overflow: "hidden",
  width: "100%",
  whiteSpace: "nowrap",
};

const scheduledAgo: CSSProperties = {
  fontSize: 12,
  fontWeight: 300,
  color: palette.slate,
  paddingBottom: 12,
};

export const divider: CSSProperties = {
  margin: 0,
  borderStyle: "solid",
  borderWidth: 0,
  borderTopWidth: 1,
  marginLeft: 7,
  marginRight: 7,
  borderColor: greys.borderGrey,
};

export const styles = {
  content,
  divider,
  background,
  h2,
  h3,
  meeting,
  meetingChevron,
  cardButton,
  cardLabel,
  scheduledAgo,
};
